import { Check } from "lucide-react";

// Per-performance control shown on every view (table grid, calendar, info modal, detail page).
// Two same-size circles:
//   • Number circle: none (white/grey "+") -> 1st (white, dark-green outline, green "1")
//     -> 2nd (white, black outline, black "2").
//   • Check circle: toggles "entered" — when entered BOTH circles fill solid green,
//     and the number stays visible inside its green circle.
// Layout: inline (side-by-side) by default, or `split` to pin the number to the parent's
// top-right corner and the check to the bottom-right corner (used by the Table grid cell).
export function PickCircle({ num, entered, onClick, onToggleEntered, testid, className = "", split = false, size = 22 }) {
  const box = num === 1
    ? "bg-[#C8000F] text-white border-2 border-[#C8000F]"
    : num === 2
      ? "bg-[#0C1017] text-white border-2 border-[#0C1017]"
      : "bg-white text-slate-400 border border-slate-300 hover:border-[#166534] hover:text-[#166534]";
  const content = num ? num : entered ? <Check className="w-3 h-3" strokeWidth={3} /> : "+";

  const numBtn = (
    <button
      onClick={(e) => { e.stopPropagation(); onClick && onClick(); }}
      data-testid={testid}
      title={num ? `Your ${num === 1 ? "1st" : "2nd"} choice — tap to change` : "Choose preference — 1st / 2nd"}
      aria-label="Choose preference"
      style={{ width: size, height: size }}
      className={`rounded-full flex items-center justify-center text-[11px] font-extrabold shadow-sm transition-colors ${box}`}>
      {content}
    </button>
  );

  const checkBtn = onToggleEntered ? (
    <button
      onClick={(e) => { e.stopPropagation(); onToggleEntered(); }}
      data-testid={testid ? `${testid}-entered` : undefined}
      title={entered ? "Entered — tap to clear" : "Mark as entered"}
      aria-label="Mark as entered"
      style={{ width: size, height: size }}
      className={`rounded-full flex items-center justify-center border-2 shadow-sm transition-colors ${
        entered ? "bg-[#16A34A] border-[#16A34A] text-white" : "bg-white border-slate-300 text-slate-400 hover:border-[#16A34A] hover:text-[#16A34A]"}`}>
      <Check className="w-3 h-3" strokeWidth={3} />
    </button>
  ) : null;

  if (split) {
    return (
      <>
        <span className="absolute top-0.5 right-0.5 z-[1]">{numBtn}</span>
        {checkBtn && <span className="absolute bottom-0.5 right-0.5 z-[1]">{checkBtn}</span>}
      </>
    );
  }

  return (
    <span className={`inline-flex shrink-0 items-center gap-1 ${className}`}>
      {numBtn}
      {checkBtn}
    </span>
  );
}
